import React from "react";
import OrderView from "../views/users/OrderView";

const Order: React.FC = () => {
    return <div><OrderView /></div>;
};

export default Order;